import type { BackupFile } from './backupSerialize';
import { createBackup } from './backupSerialize';
import { getLoan, listEvents, db } from './db';

/**
 * The one place that assembles a backup from the live local database.
 * Used by the local "Download Backup", the manual "Backup to Google
 * Drive" button, and automatic backup — so all three are guaranteed to
 * produce the identical, existing backup format (including superseded
 * events). READ-ONLY: it never writes to the database.
 */
export async function buildCurrentBackup(): Promise<BackupFile> {
  const currentLoan = await getLoan();
  const events = currentLoan ? await listEvents({ loanId: currentLoan.id, includeSuperseded: true }) : [];
  return createBackup(currentLoan, events, db.verno);
}
